import React from "react";
import { Box, CircularProgress } from "@mui/material";
import { useAuth } from "../contexts/AuthContext";
import { useDashboardProfile } from "../contexts/DashboardProfileContext";
import { ROLES } from "../config/supabase";
import Dashboard from "./Dashboard";
import TeacherHome from "./teacher/module/TeacherHome";

/**
 * Teachers see the new hub (grades, progress, upload) at /dashboard.
 * Other roles see the classic dashboard.
 * Uses profile from Auth or from TeacherOrDashboardLayout refetch so we don't flash the wrong page.
 */
const DashboardEntry = () => {
	const { user, loading } = useAuth();
	const layoutProfile = useDashboardProfile();

	if (loading) {
		return (
			<Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
				<CircularProgress size={36} sx={{ color: "#16a34a" }} />
			</Box>
		);
	}

	const role = user?.profile?.role ?? layoutProfile?.role;

	if (role === ROLES.SCHOOL_TEACHER) {
		return <TeacherHome />;
	}
	return <Dashboard />;
};

export default DashboardEntry;
